import { render, staticRenderFns } from "./ajax.vue?vue&type=template&id=a847fd36"
import script from "./ajax.vue?vue&type=script&lang=js"
export * from "./ajax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports